import { createFileRoute } from "@tanstack/react-router";
import { TruthCenterPage } from "@client/components/truth/truth-center-page";

export const Route = createFileRoute("/_app/truth/")({
  component: TruthCenterPage,
});
